import { buildCrmCard } from 'crm-cards-sdk/buildCrmCard';
import CardContent from './components/CardContent';
import { CardContext, useSetCardContextValue } from './state/CardContext';
const ObjectHighlightCard = buildCrmCard({
  displayName: 'ObjectHighlightCard',
  ContentComponent: CardContent,
  context: CardContext,
  useContextValue: useSetCardContextValue,
  useCardProps: () => ({})
});
export default ObjectHighlightCard;